import { Flex, Image, Link, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

type Props = {
	firstname: string | undefined
}

export const Footer = ({ firstname }: Props) => {
	const { t, i18n } = useTranslation()

	const securityArticleUrl =
		i18n.language === 'fr'
			? 'https://support.lydia.me/l/fr/article/zma7sln6cm-tout-savoir-sur-la-s-curit-de-lydia'
			: 'https://support.lydia.me/l/en/article/zma7sln6cm-what-are-the-app-s-security-measures'

	return (
		<Flex mt={10} flexDirection='column' alignItems='center'>
			<Image
				src={`${process.env.REACT_APP_PAYMENT_FORM_URL}l/assets/img/logos/lydia-logo-v3.png`}
				alt='Lydia Logo'
				w='103px'
				h='auto'
				mb={4}
			/>
			<Text fontFamily='Montserrat' fontSize='14px' color='#3E434F' textAlign='center'>
				{t('phone_form.footer_text', { firstname: firstname })}
			</Text>
			<Link
				href='https://www.lydia.me/'
				target='_blank'
				rel='noopener noreferrer'
				fontFamily='Montserrat'
				fontSize='14px'
				color='#3E434F'
			>
				{t('phone_form.footer_link')}
			</Link>
			<Link
				mt={1}
				href={securityArticleUrl}
				target='_blank'
				rel='noopener noreferrer'
				fontFamily='Montserrat'
				fontSize='14px'
				color='#697284'
			>
				{t('phone_form.footer_know_more')}
			</Link>
		</Flex>
	)
}
